export default {
  userStore: {
    ranInitialValidation: true
  }
};
